<script setup>

import Button from "@/components/common/input/Button";

const props = defineProps({

  modelValue: {},
  width: {type: String, default: '100%'},
  height: {type: String, default: 'auto'},
  title: {type: String, default: 'Title'},
  showClose: {type: Boolean, default: true}

});

const emits = defineEmits(['update:modelValue', 'close'])

function handleClose() {

  emits('update:modelValue', false);
  emits('close');

}

</script>

<template class="cmp-modal">
  <div v-show="modelValue" class="cmp-modal_backdrop"  data-cy="cmpModalWindow">
    <div class="cmp-modal_wrapper" :style="{width:width}">
      <header class="cmp-modal_header global-center-items">
        <slot name="icon"></slot><slot name="header">{{ title }}</slot> <span style="font-weight: normal"><slot name="extra"></slot></span>
        <div title="Close" @click="handleClose()" class="cmp-modal_close"><span>&#735</span> </div>
      </header>
      <section class="cmp-modal_body" :style="{height:height}">
        <slot name="body"></slot>
      </section>
      <footer data-cy="cmpModalFooter" class="cmp-modal_footer">
        <slot name="footer"></slot>
        <Button
            data-cy="btnModalOkButton"
            v-if="props.showClose"
            @click="emits('update:modelValue', false)"
            text="Close"
            type="toolbar">
        </Button>
      </footer>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.cmp-modal {

  &_backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(153, 152, 152, 0.38);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(2px);
  }

  &_wrapper {
    border-radius: 4px;
    border: 1px solid #b7b7b7;
    background-color: #fdfdfd;
    user-select: none;
    animation: fadeIn 1s;
    -webkit-animation: fadeIn 0.5s;
    -moz-animation: fadeIn 0.5s;
    //max-width: 1650px;
  }

  &_header {
    position: relative;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    border-bottom: 1px solid #eeeeee;
    color: #282828;
    height: 34px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    gap: 10px;
    padding-left: 10px;
    background: #f3f3f3;
  }

  &_body {
    position: relative;
    padding: 10px 40px;
    overflow-x: auto;
    overflow-y: hidden;
    background: #fcfcfc;

  }

  &_footer {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    padding: 5px;
    display: flex;
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
    background: #fafafa;
    height: 24px;
  }

  &_close {
    position: absolute;
    right: 10px;
    top: 6px;
    font-size: 35px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
  }

  &_close span {
    padding-top: 14px;
  }

  &_close:hover {
    background-color: #b04545;
    color: #fff;
  }

}

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-moz-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

@-webkit-keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

</style>
